export class Price {
    constructor(price) {
        this.price = price;
        this.error =
            this.price.dataset.formatError ?? "Price format must be 123.45";
        this.price.addEventListener("input", () => this.onChanged());
    }
    static create(form) {
        const price = form.querySelector("#price");
        if (price === null) {
            return null;
        }
        return new Price(price);
    }
    validate() {
        return this.price.value.match(/^\d+(?:\.\d+)?$/) ? null : this.error;
    }
    onChanged() { }
}
